<template>
  <master-page>
    <br/>
    <v-card>
      <v-card-title>
        <v-icon large left>mdi-star-check</v-icon>
        <span class="title font-weight-light">Avaliação de Beneficiário</span>
        <v-spacer/>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon color="click" v-on="on" @click="AbrirRelatorio()">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </template>
          <span>Relatório</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="click" v-on="on" @click="NovaAvaliacao()">
              <v-icon style="color:white">mdi-plus</v-icon>
              <span style="color:white">Nova Avaliação</span>
            </v-btn>
          </template>
          <span>Nova Avaliação</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon color="click" v-on="on" @click="CarregarTudo()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Atualizar</span>
        </v-tooltip>
        <info/>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete v-model="beneficiarioId" :items="beneficiariosBusca" :loading="loadingBusca" :search-input.sync="buscaBeneficiario" hide-no-data clearable item-text="nome" item-value="id" label="Pesquisar beneficiário" placeholder="Nome, matrícula, CPF ou projeto" dense outlined @change="SelecionarBeneficiario">
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.nome }}</v-list-item-title>
                  <v-list-item-subtitle>Matrícula: {{ item.matricula || '-' }} | CPF: {{ item.cpfCnpj || '-' }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>

            <section class="resumo-panel mb-4">
              <div class="resumo-foto">
                <v-img v-if="fotoBeneficiario" :src="fotoBeneficiario" max-height="120" contain/>
                <v-icon v-else size="72" color="#90a4ae">mdi-account-child</v-icon>
              </div>
              <div class="resumo-nome">{{ resumoBeneficiario.nome || 'Base institucional' }}</div>
              <div class="resumo-linha">Matrícula: {{ resumoBeneficiario.matricula || '-' }}</div>
              <div class="resumo-linha">Nascimento: {{ DataNascimento(resumoBeneficiario) }}</div>
              <div class="resumo-linha">Responsável: {{ resumoBeneficiario.responsavel || '-' }}</div>
              <div class="mt-2">
                <v-chip v-for="projeto in resumoBeneficiario.projetos" :key="projeto.id" small class="mr-1 mb-1" :color="projeto.aberto ? 'green lighten-4' : 'red lighten-5'" :text-color="projeto.aberto ? 'green darken-4' : 'red darken-4'">
                  {{ projeto.codigoNome }}
                </v-chip>
                <span v-if="!resumoBeneficiario.projetos || resumoBeneficiario.projetos.length == 0" class="resumo-linha">Sem projetos ativos</span>
              </div>
              <v-btn v-if="resumoBeneficiario.id" small text color="primary" class="mt-2 px-0" @click="AbrirCadastroBeneficiario()">
                <v-icon small left>mdi-open-in-new</v-icon>
                Cadastro completo
              </v-btn>
            </section>

            <section class="tipo-panel">
              <div class="d-flex align-center mb-2">
                <span class="panel-title">Modelos de avaliação</span>
                <v-spacer/>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small color="click" v-on="on" @click="NovoModelo()">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Novo modelo</span>
                </v-tooltip>
              </div>

              <v-list dense class="tipo-lista">
                <v-list-item v-for="modelo in modelos" :key="modelo.id">
                  <v-list-item-avatar size="22" :style="`background-color:${modelo.cor}`"/>
                  <v-list-item-content>
                    <v-list-item-title>{{ modelo.nome }}</v-list-item-title>
                    <v-list-item-subtitle>{{ modelo.ativo ? 'Ativo' : 'Inativo' }} | {{ modelo.frequenciaDias }} dias | {{ modelo.quantidadeItens }} itens</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="tipo-actions">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" @click="EditarModelo(modelo)">mdi-pencil</v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" @click="AlternarModelo(modelo)">{{ modelo.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline' }}</v-icon>
                      </template>
                      <span>{{ modelo.ativo ? 'Inativar' : 'Ativar' }}</span>
                    </v-tooltip>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </section>
          </v-col>

          <v-col cols="12" md="8">
            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete v-model="beneficiarioId" :items="beneficiariosBusca" :loading="loadingBusca" :search-input.sync="buscaBeneficiarioFiltro" hide-no-data clearable item-text="nome" item-value="id" label="Beneficiário" dense outlined @change="SelecionarBeneficiario"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="filtro.dataInicial" type="date" label="Data inicial" dense outlined @change="CarregarTimeline()"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="filtro.dataFinal" type="date" label="Data final" dense outlined @change="CarregarTimeline()"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select v-model="filtro.avaliacaoModeloId" :items="modelosAtivos" item-value="id" item-text="nome" label="Tipo de avaliação" clearable dense outlined @change="CarregarTimeline()"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete v-model="filtro.projetoId" :items="projetosBusca" :loading="loadingProjeto" :search-input.sync="buscaProjeto" hide-no-data clearable item-text="nome" item-value="id" label="Projeto" dense outlined @change="CarregarTimeline()"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete v-model="filtro.usuarioId" :items="usuariosBusca" :loading="loadingUsuario" :search-input.sync="buscaUsuario" hide-no-data clearable item-text="nome" item-value="id" label="Responsável" dense outlined @change="CarregarTimeline()"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select v-model="filtro.statusFrequencia" :items="statusFrequencia" item-value="id" item-text="nome" label="Status da frequência" clearable dense outlined @change="CarregarTimeline()"/>
              </v-col>
            </v-row>

            <div class="timeline-list">
              <v-skeleton-loader v-if="loadingTimeline" type="list-item-three-line"/>
              <v-alert v-else-if="timeline.length == 0" outlined type="info" dense>
                Nenhuma avaliação encontrada.
              </v-alert>
              <div v-for="tipo in timeline" :key="tipo.avaliacaoModeloId" class="timeline-item">
                <div class="timeline-marker" :style="`background-color:${tipo.cor || '#607D8B'}`"/>
                <div class="timeline-content">
                  <div class="d-flex align-center">
                    <strong>{{ tipo.nome }}</strong>
                    <v-spacer/>
                    <span class="star-readonly">{{ Estrelas(tipo.media) }}</span>
                    <v-btn icon small @click="ExpandirTipo(tipo)">
                      <v-icon>{{ tipo.aberto ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </div>
                  <div class="timeline-title">{{ beneficiarioId ? `Média: ${FormatarMedia(tipo.media)}` : `Média Geral: ${FormatarMedia(tipo.media)}` }}</div>
                  <div v-if="beneficiarioId" class="timeline-subtitle">
                    {{ tipo.quantidadeAvaliacoes }} avaliações | Frequência: {{ tipo.frequenciaDias }} dias | Próxima: {{ DataSimples(tipo.proximaAvaliacao) }}
                  </div>
                  <div v-else class="timeline-subtitle">
                    {{ tipo.quantidadeAvaliacoes }} avaliações | {{ tipo.quantidadeBeneficiarios }} beneficiários | Frequência: {{ tipo.frequenciaDias }} dias
                  </div>
                  <div class="mt-2">
                    <v-chip small :color="StatusCor(tipo.statusFrequencia)" text-color="white">{{ tipo.statusFrequenciaDescricao }}</v-chip>
                    <v-chip v-if="!beneficiarioId" small class="ml-1" color="green darken-2" text-color="white">{{ tipo.percentualEmDia }}% em dia</v-chip>
                    <v-chip v-if="!beneficiarioId && tipo.quantidadeAtrasadas > 0" small class="ml-1" color="red darken-2" text-color="white">{{ tipo.quantidadeAtrasadas }} atrasadas</v-chip>
                  </div>

                  <v-expand-transition>
                    <div v-if="tipo.aberto" class="timeline-nested">
                      <v-skeleton-loader v-if="tipo.loading" type="list-item-two-line"/>
                      <template v-else-if="beneficiarioId">
                        <div v-for="avaliacao in tipo.avaliacoes" :key="avaliacao.id" class="nested-card" @click="ExpandirAvaliacao(avaliacao)">
                          <div class="d-flex align-center">
                            <strong>{{ DataSimples(avaliacao.dataAvaliacao) }} — Média {{ FormatarMedia(avaliacao.media) }}</strong>
                            <v-spacer/>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn icon small class="mr-1" v-on="on" @click.stop="EditarAvaliacao(avaliacao)">
                                  <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                              </template>
                              <span>Editar</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn icon small class="mr-1" v-on="on" @click.stop="ExcluirAvaliacao(avaliacao)">
                                  <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>Excluir</span>
                            </v-tooltip>
                            <v-icon small>{{ avaliacao.aberto ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                          </div>
                          <div class="timeline-subtitle">{{ avaliacao.responsavel || '-' }} | {{ avaliacao.projeto || 'Sem projeto' }}</div>
                          <div class="timeline-text">{{ ResumoTexto(avaliacao.observacao) }}</div>
                          <ItensAvaliacao :avaliacao="avaliacao"/>
                        </div>
                      </template>
                      <template v-else>
                        <div v-for="beneficiario in tipo.beneficiarios" :key="beneficiario.beneficiarioId" class="nested-card" @click="ExpandirBeneficiario(tipo, beneficiario)">
                          <div class="d-flex align-center">
                            <strong>{{ beneficiario.nome }}</strong>
                            <v-spacer/>
                            <span>Média: {{ FormatarMedia(beneficiario.media) }}</span>
                            <v-icon small class="ml-2">{{ beneficiario.aberto ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                          </div>
                          <div class="timeline-subtitle">Matrícula: {{ beneficiario.matricula || '-' }} | {{ beneficiario.quantidadeAvaliacoes }} avaliações</div>
                          <v-chip x-small :color="StatusCor(beneficiario.statusFrequencia)" text-color="white">{{ beneficiario.statusFrequenciaDescricao }}</v-chip>
                          <v-expand-transition>
                            <div v-if="beneficiario.aberto" class="timeline-nested">
                              <v-skeleton-loader v-if="beneficiario.loading" type="list-item-two-line"/>
                              <div v-for="avaliacao in beneficiario.avaliacoes" :key="avaliacao.id" class="nested-card" @click.stop="ExpandirAvaliacao(avaliacao)">
                                <div class="d-flex align-center">
                                  <strong>{{ DataSimples(avaliacao.dataAvaliacao) }} — Média {{ FormatarMedia(avaliacao.media) }}</strong>
                                  <v-spacer/>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn icon small class="mr-1" v-on="on" @click.stop="EditarAvaliacao(avaliacao)">
                                        <v-icon small>mdi-pencil</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Editar</span>
                                  </v-tooltip>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn icon small class="mr-1" v-on="on" @click.stop="ExcluirAvaliacao(avaliacao)">
                                        <v-icon small>mdi-delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Excluir</span>
                                  </v-tooltip>
                                  <v-icon small>{{ avaliacao.aberto ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                </div>
                                <div class="timeline-subtitle">{{ avaliacao.responsavel || '-' }} | {{ avaliacao.projeto || 'Sem projeto' }}</div>
                                <div class="timeline-text">{{ ResumoTexto(avaliacao.observacao) }}</div>
                                <ItensAvaliacao :avaliacao="avaliacao"/>
                              </div>
                            </div>
                          </v-expand-transition>
                        </div>
                      </template>
                    </div>
                  </v-expand-transition>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogModelo" max-width="760">
      <v-card>
        <v-card-title>Modelo de avaliação</v-card-title>
        <v-card-text>
          <v-form ref="formModelo" v-model="validModelo" lazy-validation>
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field v-model="modelo.nome" label="Nome" :rules="fieldRules" counter="120" maxlength="120" dense outlined/>
              </v-col>
              <v-col cols="12" md="4">
                <v-menu v-model="menuCorModelo" :close-on-content-click="false" offset-y max-width="290">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="modelo.cor" label="Cor" dense outlined readonly v-on="on">
                      <template v-slot:append>
                        <span class="color-field-preview" :style="`background-color:${modelo.cor || '#607D8B'}`"/>
                      </template>
                    </v-text-field>
                  </template>
                  <v-card>
                    <v-color-picker v-model="modelo.cor" mode="hexa" hide-mode-switch show-swatches swatches-max-height="120"/>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="modelo.descricao" label="Descrição" counter="500" maxlength="500" dense outlined/>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model.number="modelo.frequenciaDias" type="number" label="Reavaliar a cada X dias" :rules="fieldRules" dense outlined/>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model.number="modelo.alertaVencimentoDias" type="number" label="Alertar vencimento" dense outlined/>
              </v-col>
              <v-col cols="12" md="4">
                <v-switch v-model="modelo.ativo" label="Ativo" dense/>
              </v-col>
              <v-col cols="12">
                <div class="d-flex align-center mb-2">
                  <span class="panel-title">Itens avaliativos</span>
                  <v-spacer/>
                  <v-btn small text color="primary" @click="AdicionarItemModelo()">
                    <v-icon small left>mdi-plus</v-icon>
                    Item
                  </v-btn>
                </div>
                <v-row dense v-for="(item, index) in modelo.itens" :key="`modelo-item-${index}`">
                  <v-col cols="12" md="7">
                    <v-text-field v-model="item.nome" label="Nome" :rules="fieldRules" dense outlined/>
                  </v-col>
                  <v-col cols="6" md="2">
                    <v-text-field v-model.number="item.ordem" type="number" label="Ordem" dense outlined/>
                  </v-col>
                  <v-col cols="4" md="2">
                    <v-switch v-model="item.ativo" label="Ativo" dense/>
                  </v-col>
                  <v-col cols="2" md="1" class="d-flex align-center">
                    <v-btn icon small color="red" @click="RemoverItemModelo(index)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="dialogModelo = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="SalvarModelo()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAvaliacao" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
          <v-btn icon dark @click="dialogAvaliacao = false"><v-icon>mdi-close</v-icon></v-btn>
          <v-toolbar-title>Avaliação do Beneficiário</v-toolbar-title>
          <v-spacer/>
          <v-toolbar-items>
            <v-btn dark text @click="SalvarAvaliacao()" :disabled="!validAvaliacao">Salvar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-form ref="formAvaliacao" v-model="validAvaliacao" lazy-validation>
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete v-model="avaliacao.beneficiarioId" :items="beneficiariosBusca" :loading="loadingBusca" :search-input.sync="buscaBeneficiarioAvaliacao" hide-no-data item-text="nome" item-value="id" label="Beneficiário" :rules="fieldRules" dense outlined @change="SelecionarBeneficiarioAvaliacao()"/>
              </v-col>
              <v-col cols="12" md="3">
                <v-select v-model="avaliacao.avaliacaoModeloId" :items="modelosAtivos" item-value="id" item-text="nome" label="Tipo de avaliação" :rules="fieldRules" dense outlined @change="CarregarItensAvaliacao()"/>
              </v-col>
              <v-col cols="12" md="3">
                <v-select v-model="avaliacao.projetoId" :items="projetosAvaliacao" item-value="id" item-text="codigoNome" label="Projeto" clearable dense outlined/>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field v-model="avaliacao.dataAvaliacao" type="date" label="Data da avaliação" :rules="fieldRules" dense outlined/>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete v-model="avaliacao.usuarioId" :items="usuariosBusca" :loading="loadingUsuario" :search-input.sync="buscaUsuarioAvaliacao" hide-no-data item-text="nome" item-value="id" label="Responsável" :rules="fieldRules" dense outlined/>
              </v-col>
              <v-col cols="12">
                <div class="panel-title mb-2">Itens avaliativos</div>
                <div v-for="item in itensAvaliacao" :key="item.avaliacaoModeloItemId" class="avaliacao-item">
                  <div class="avaliacao-item-nome">{{ item.nome }}</div>
                  <div class="star-picker" @mouseleave="LimparHoverNota(item)">
                    <v-icon v-for="n in 5" :key="n" :color="n <= NotaVisual(item) ? 'amber darken-2' : 'blue-grey lighten-3'" @mouseenter="SetHoverNota(item, n)" @click="item.nota = n">
                      {{ n <= NotaVisual(item) ? 'mdi-star' : 'mdi-star-outline' }}
                    </v-icon>
                    <v-btn x-small text color="blue-grey" @click="item.nota = 0">0</v-btn>
                  </div>
                </div>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="avaliacao.observacao" label="Observação geral" counter="2000" maxlength="2000" dense outlined/>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <cadastro-beneficiario v-model="dialogBeneficiario" :item="beneficiarioCadastro" @fechou="dialogBeneficiario = false" @salvou="SelecionarBeneficiario()"/>

    <v-overlay :value="loadingGeral">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>
  </master-page>
</template>

<script>
import BeneficiarioService from '@/core/services/projetos/BeneficiarioService';
import ProjetoService from '@/core/services/projetos/ProjetoService';
import UsuarioService from '@/core/services/geral/UsuarioService';
import { AvaliacaoModeloService, BeneficiarioAvaliacaoService } from '@/core/services/projetos';
import { AvaliacaoModelo, AvaliacaoModeloItem, BeneficiarioAvaliacao, Beneficiario } from '@/core/domain/projetos';

const ItensAvaliacao = {
  props: ['avaliacao'],
  template: `
    <v-expand-transition>
      <div v-if="avaliacao.aberto" class="timeline-nested" @click.stop>
        <v-skeleton-loader v-if="avaliacao.loading" type="list-item-two-line"/>
        <div v-for="item in avaliacao.itens" :key="item.id" class="avaliacao-item compacto">
          <div class="avaliacao-item-nome">{{ item.nome }}</div>
          <div class="star-readonly">{{ estrelas(item.nota) }}</div>
        </div>
      </div>
    </v-expand-transition>
  `,
  methods: {
    estrelas(nota){
      const valor = Math.round(nota || 0);
      return '★'.repeat(valor) + '☆'.repeat(5 - valor);
    }
  }
};

export default {
  components: { ItensAvaliacao },
  data: () => ({
    beneficiarioService: new BeneficiarioService(),
    projetoService: new ProjetoService(),
    usuarioService: new UsuarioService(),
    avaliacaoService: new BeneficiarioAvaliacaoService(),
    modeloService: new AvaliacaoModeloService(),
    beneficiarioId: null,
    beneficiariosBusca: [],
    buscaBeneficiario: '',
    buscaBeneficiarioFiltro: '',
    buscaBeneficiarioAvaliacao: '',
    loadingBusca: false,
    resumoBeneficiario: { projetos: [] },
    fotoBeneficiario: '',
    modelos: [],
    timeline: [],
    projetosBusca: [],
    projetosAvaliacao: [],
    buscaProjeto: '',
    loadingProjeto: false,
    usuariosBusca: [],
    buscaUsuario: '',
    buscaUsuarioAvaliacao: '',
    loadingUsuario: false,
    filtro: {
      dataInicial: '',
      dataFinal: '',
      avaliacaoModeloId: null,
      projetoId: null,
      usuarioId: null,
      statusFrequencia: ''
    },
    statusFrequencia: [
      { id: 'E', nome: 'Em dia' },
      { id: 'P', nome: 'Próximo vencimento' },
      { id: 'A', nome: 'Atrasado' }
    ],
    modelo: new AvaliacaoModelo(),
    avaliacao: new BeneficiarioAvaliacao(),
    itensAvaliacao: [],
    hoverNotas: {},
    beneficiarioCadastro: new Beneficiario(),
    dialogModelo: false,
    dialogAvaliacao: false,
    dialogBeneficiario: false,
    menuCorModelo: false,
    validModelo: true,
    validAvaliacao: true,
    loadingGeral: false,
    loadingTimeline: false,
    fieldRules: [v => !!v || v === 0 || 'Campo obrigatório']
  }),
  computed: {
    modelosAtivos(){
      return this.modelos.filter(x => x.ativo);
    }
  },
  watch: {
    buscaBeneficiario(val){ this.BuscarBeneficiarios(val); },
    buscaBeneficiarioFiltro(val){ this.BuscarBeneficiarios(val); },
    buscaBeneficiarioAvaliacao(val){ this.BuscarBeneficiarios(val); },
    buscaProjeto(val){
      if(!val || val.length < 2 || this.loadingProjeto)
        return;

      this.loadingProjeto = true;
      this.projetoService.AutoComplete(val).then(
        res => this.projetosBusca = res.data,
        err => this.MostrarErro(err)
      ).finally(() => this.loadingProjeto = false);
    },
    buscaUsuario(val){ this.BuscarUsuarios(val); },
    buscaUsuarioAvaliacao(val){ this.BuscarUsuarios(val); }
  },
  methods: {
    CarregarTudo(){
      this.CarregarModelos();
      this.CarregarTimeline();
    },
    AbrirRelatorio(){
      const routeLink = this.$router.resolve({
        name: 'relatorioAvaliacaoBeneficiario',
        query: this.FiltroPayload()
      });

      window.open(routeLink.href, '_blank');
    },
    CarregarModelos(){
      this.modeloService.Resumo().then(
        res => this.modelos = res.data,
        err => this.MostrarErro(err)
      );
    },
    BuscarBeneficiarios(val){
      if(!val || val.length < 2 || this.loadingBusca)
        return;

      this.loadingBusca = true;
      this.avaliacaoService.BuscarBeneficiario(val).then(
        res => this.beneficiariosBusca = res.data,
        err => this.MostrarErro(err)
      ).finally(() => this.loadingBusca = false);
    },
    BuscarUsuarios(val){
      if(!val || val.length < 2 || this.loadingUsuario)
        return;

      this.loadingUsuario = true;
      this.usuarioService.AutoComplete(val).then(
        res => this.usuariosBusca = res.data,
        err => this.MostrarErro(err)
      ).finally(() => this.loadingUsuario = false);
    },
    SelecionarBeneficiario(){
      if(!this.beneficiarioId){
        this.resumoBeneficiario = { projetos: [] };
        this.fotoBeneficiario = '';
        this.CarregarTimeline();
        return;
      }

      this.loadingGeral = true;
      this.avaliacaoService.ResumoBeneficiario(this.beneficiarioId).then(
        res => {
          this.resumoBeneficiario = res.data;
          this.CarregarFotoBeneficiario();
          this.CarregarTimeline();
        },
        err => this.MostrarErro(err)
      ).finally(() => this.loadingGeral = false);
    },
    SelecionarBeneficiarioAvaliacao(){
      this.projetosAvaliacao = [];
      if(!this.avaliacao.beneficiarioId)
        return;

      this.avaliacaoService.ResumoBeneficiario(this.avaliacao.beneficiarioId).then(
        res => this.projetosAvaliacao = res.data.projetos.filter(x => x.aberto),
        err => this.MostrarErro(err)
      );
    },
    CarregarFotoBeneficiario(){
      this.fotoBeneficiario = '';
      this.beneficiarioService.Foto(this.resumoBeneficiario.id).then(
        res => this.fotoBeneficiario = res.data,
        () => this.fotoBeneficiario = ''
      );
    },
    CarregarTimeline(){
      this.loadingTimeline = true;
      this.avaliacaoService.TimelineResumo(this.FiltroPayload()).then(
        res => this.timeline = res.data.map(x => Object.assign(x, { aberto: false, loading: false, avaliacoes: [], beneficiarios: [] })),
        err => this.MostrarErro(err)
      ).finally(() => this.loadingTimeline = false);
    },
    FiltroPayload(extra = {}){
      return Object.assign({
        beneficiarioId: this.beneficiarioId,
        dataInicial: this.filtro.dataInicial,
        dataFinal: this.filtro.dataFinal,
        avaliacaoModeloId: this.filtro.avaliacaoModeloId,
        projetoId: this.filtro.projetoId,
        usuarioId: this.filtro.usuarioId,
        statusFrequencia: this.filtro.statusFrequencia
      }, extra);
    },
    ExpandirTipo(tipo){
      tipo.aberto = !tipo.aberto;
      if(!tipo.aberto || tipo.loading)
        return;

      if(this.beneficiarioId && tipo.avaliacoes.length > 0)
        return;
      if(!this.beneficiarioId && tipo.beneficiarios.length > 0)
        return;

      tipo.loading = true;
      const filtro = this.FiltroPayload({ avaliacaoModeloId: tipo.avaliacaoModeloId });
      const request = this.beneficiarioId ? this.avaliacaoService.TimelineAvaliacoes(filtro) : this.avaliacaoService.TimelineBeneficiarios(filtro);
      request.then(
        res => {
          const lista = res.data.map(x => Object.assign(x, { aberto: false, loading: false, avaliacoes: [], itens: [] }));
          if(this.beneficiarioId)
            this.$set(tipo, 'avaliacoes', lista);
          else
            this.$set(tipo, 'beneficiarios', lista);
        },
        err => this.MostrarErro(err)
      ).finally(() => tipo.loading = false);
    },
    ExpandirBeneficiario(tipo, beneficiario){
      beneficiario.aberto = !beneficiario.aberto;
      if(!beneficiario.aberto || beneficiario.loading || beneficiario.avaliacoes.length > 0)
        return;

      beneficiario.loading = true;
      this.avaliacaoService.TimelineAvaliacoes(this.FiltroPayload({
        avaliacaoModeloId: tipo.avaliacaoModeloId,
        beneficiarioId: beneficiario.beneficiarioId
      })).then(
        res => this.$set(beneficiario, 'avaliacoes', res.data.map(x => Object.assign(x, { aberto: false, loading: false, itens: [] }))),
        err => this.MostrarErro(err)
      ).finally(() => beneficiario.loading = false);
    },
    ExpandirAvaliacao(avaliacao){
      avaliacao.aberto = !avaliacao.aberto;
      if(!avaliacao.aberto || avaliacao.loading || avaliacao.itens.length > 0)
        return;

      avaliacao.loading = true;
      this.avaliacaoService.TimelineItens(avaliacao.id).then(
        res => this.$set(avaliacao, 'itens', res.data),
        err => this.MostrarErro(err)
      ).finally(() => avaliacao.loading = false);
    },
    NovoModelo(){
      this.modelo = new AvaliacaoModelo();
      this.modelo.itens = [];
      if(this.$refs.formModelo)
        this.$refs.formModelo.resetValidation();
      this.dialogModelo = true;
    },
    EditarModelo(modelo){
      this.modeloService.ObterPorId(modelo.id, 'Itens').then(
        res => {
          this.modelo = new AvaliacaoModelo(res.data);
          this.dialogModelo = true;
        },
        err => this.MostrarErro(err)
      );
    },
    AlternarModelo(modelo){
      this.modeloService.ObterPorId(modelo.id, 'Itens').then(
        res => {
          const item = new AvaliacaoModelo(res.data);
          item.ativo = !item.ativo;
          this.modeloService.Salvar(this.PrepararPayload(item)).then(
            () => this.CarregarModelos(),
            err => this.MostrarErro(err)
          );
        },
        err => this.MostrarErro(err)
      );
    },
    AdicionarItemModelo(){
      this.modelo.itens.push(new AvaliacaoModeloItem({ ordem: this.modelo.itens.length + 1, ativo: true }));
    },
    RemoverItemModelo(index){
      if(this.modelo.itens[index].id > 0)
        this.modelo.itens[index].ativo = false;
      else
        this.modelo.itens.splice(index, 1);
    },
    SalvarModelo(){
      if(!this.$refs.formModelo.validate())
        return;

      this.modelo.itens.forEach((item, index) => item.ordem = item.ordem || index + 1);
      this.modeloService.Salvar(this.PrepararPayload(new AvaliacaoModelo(this.modelo))).then(
        () => {
          this.$swal('Aviso', 'Operação realizada com sucesso!', 'success');
          this.dialogModelo = false;
          this.CarregarModelos();
          this.CarregarTimeline();
        },
        err => this.MostrarErro(err)
      );
    },
    NovaAvaliacao(){
      const session = JSON.parse(localStorage.sessionApp);
      this.avaliacao = new BeneficiarioAvaliacao({
        beneficiarioId: this.beneficiarioId || 0,
        usuarioId: session.usuarioId,
        dataAvaliacao: new Date().yyyymmdd()
      });
      this.itensAvaliacao = [];
      this.projetosAvaliacao = this.resumoBeneficiario && this.resumoBeneficiario.projetos ? this.resumoBeneficiario.projetos.filter(x => x.aberto) : [];
      if(session.usuarioId && session.usuarioNome)
        this.usuariosBusca = [{ id: session.usuarioId, nome: session.usuarioNome }];
      this.dialogAvaliacao = true;
    },
    EditarAvaliacao(item){
      this.loadingGeral = true;
      this.avaliacaoService.ObterPorId(item.id, 'Itens,Beneficiario,AvaliacaoModelo,Projeto,Usuario').then(
        res => {
          this.avaliacao = new BeneficiarioAvaliacao(res.data);
          this.itensAvaliacao = [];

          if(res.data.beneficiario)
            this.beneficiariosBusca = [res.data.beneficiario];
          if(res.data.usuario)
            this.usuariosBusca = [res.data.usuario];

          this.avaliacaoService.ResumoBeneficiario(this.avaliacao.beneficiarioId).then(
            resumo => this.projetosAvaliacao = resumo.data.projetos.filter(x => x.aberto),
            err => this.MostrarErro(err)
          );

          this.CarregarItensAvaliacao(this.avaliacao.itens);
          this.dialogAvaliacao = true;
        },
        err => this.MostrarErro(err)
      ).finally(() => this.loadingGeral = false);
    },
    ExcluirAvaliacao(item){
      this.$swal({
        title: 'Confirma a exclusão?',
        text: 'Essa operação não poderá ser desfeita.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não'
      }).then(result => {
        if(result.value){
          this.loadingGeral = true;
          this.avaliacaoService.Excluir(item.id).then(
            () => {
              this.$swal('Aviso', 'Avaliação excluída com sucesso!', 'success');
              this.CarregarTimeline();
            },
            err => this.MostrarErro(err)
          ).finally(() => this.loadingGeral = false);
        }
      });
    },
    CarregarItensAvaliacao(itensSalvos = []){
      if(!this.avaliacao.avaliacaoModeloId){
        this.itensAvaliacao = [];
        return;
      }

      this.modeloService.ObterPorId(this.avaliacao.avaliacaoModeloId, 'Itens').then(
        res => {
          const completo = new AvaliacaoModelo(res.data);
          this.itensAvaliacao = completo.itens
            .filter(x => x.ativo)
            .sort((a, b) => a.ordem - b.ordem)
            .map(x => {
              const itemSalvo = itensSalvos.find(y => y.avaliacaoModeloItemId == x.id);
              return {
                id: itemSalvo ? itemSalvo.id : 0,
                avaliacaoModeloItemId: x.id,
                nome: x.nome,
                nota: itemSalvo ? itemSalvo.nota : 0
              };
            });
        },
        err => this.MostrarErro(err)
      );
    },
    SalvarAvaliacao(){
      if(!this.$refs.formAvaliacao.validate())
        return;

      const model = new BeneficiarioAvaliacao(this.avaliacao);
      model.itens = this.itensAvaliacao.map(x => ({
        id: x.id ? x.id : 0,
        empresaId: 0,
        beneficiarioAvaliacaoId: model.id,
        avaliacaoModeloItemId: x.avaliacaoModeloItemId,
        nota: x.nota
      }));

      this.loadingGeral = true;
      this.avaliacaoService.Salvar(this.PrepararPayload(model)).then(
        () => {
          this.$swal('Aviso', 'Operação realizada com sucesso!', 'success');
          this.dialogAvaliacao = false;
          if(this.beneficiarioId)
            this.SelecionarBeneficiario();
          else
            this.CarregarTimeline();
        },
        err => this.MostrarErro(err)
      ).finally(() => this.loadingGeral = false);
    },
    PrepararPayload(model){
      const payload = JSON.parse(JSON.stringify(model));
      delete payload.createdAt;
      delete payload.updatedAt;
      delete payload.beneficiario;
      delete payload.projeto;
      delete payload.usuario;
      delete payload.avaliacaoModelo;
      if(payload.itens)
        payload.itens.forEach(x => {
          delete x.avaliacaoModelo;
          delete x.avaliacaoModeloItem;
          delete x.beneficiarioAvaliacao;
        });
      return payload;
    },
    AbrirCadastroBeneficiario(){
      this.beneficiarioService.ObterPorId(this.resumoBeneficiario.id).then(
        res => {
          this.beneficiarioCadastro = new Beneficiario(res.data);
          this.dialogBeneficiario = true;
        },
        err => this.MostrarErro(err)
      );
    },
    NotaVisual(item){
      return this.hoverNotas[item.avaliacaoModeloItemId] || item.nota || 0;
    },
    SetHoverNota(item, nota){
      this.$set(this.hoverNotas, item.avaliacaoModeloItemId, nota);
    },
    LimparHoverNota(item){
      this.$set(this.hoverNotas, item.avaliacaoModeloItemId, null);
    },
    Estrelas(media){
      const valor = Math.round(media || 0);
      return '★'.repeat(valor) + '☆'.repeat(5 - valor);
    },
    FormatarMedia(value){
      return (value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },
    DataSimples(value){
      if(!value)
        return '-';
      return new Date(value).ddmmyyyy();
    },
    DataNascimento(item){
      if(!item || !item.dataNascimentoFundacao)
        return '-';
      const data = new Date(item.dataNascimentoFundacao);
      return `${data.ddmmyyyy()} / ${item.idade || 0} anos`;
    },
    ResumoTexto(value){
      if(!value)
        return '-';
      return value.length > 160 ? `${value.substring(0, 160)}...` : value;
    },
    StatusCor(status){
      if(status == 'A') return 'red darken-2';
      if(status == 'P') return 'orange darken-2';
      return 'green darken-2';
    },
    MostrarErro(err){
      const data = err && err.response ? err.response.data : err;
      let mensagem = 'Não foi possível concluir a operação.';

      if(typeof data === 'string')
        mensagem = data;
      else if(data && data.errors){
        const mensagens = [];
        Object.keys(data.errors).forEach(campo => {
          const erros = Array.isArray(data.errors[campo]) ? data.errors[campo] : [data.errors[campo]];
          erros.filter(x => !!x).forEach(erro => mensagens.push(erro));
        });
        mensagem = mensagens.length > 0 ? mensagens.join('<br/>') : (data.title || mensagem);
      }
      else if(data && data.title)
        mensagem = data.title;
      else if(data && data.message)
        mensagem = data.message;

      this.$swal({
        title: 'Aviso',
        html: mensagem,
        icon: err && err.response && err.response.status == 400 ? 'warning' : 'error'
      });
    }
  },
  mounted(){
    this.CarregarTudo();
  }
}
</script>

<style scoped>
.resumo-panel,
.tipo-panel {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 14px;
  background: #fbfcfd;
}

.resumo-foto {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef3f7;
  border-radius: 6px;
  margin-bottom: 10px;
}

.resumo-nome {
  font-size: 17px;
  font-weight: 700;
  color: #263238;
}

.resumo-linha {
  font-size: 13px;
  color: #607d8b;
  line-height: 1.7;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: #37474f;
}

.color-field-preview {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.18);
}

.tipo-lista {
  max-height: 360px;
  overflow-y: auto;
}

.tipo-actions {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.timeline-list {
  position: relative;
}

.timeline-item {
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: 10px;
  margin-bottom: 12px;
}

.timeline-marker {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-top: 9px;
}

.timeline-content {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 12px;
  background: #ffffff;
}

.timeline-title {
  font-weight: 700;
  color: #263238;
  margin-top: 4px;
}

.timeline-subtitle {
  font-size: 12px;
  color: #78909c;
  margin-top: 2px;
}

.timeline-text {
  color: #455a64;
  margin-top: 8px;
  white-space: pre-line;
}

.timeline-nested {
  margin-top: 10px;
}

.nested-card {
  border: 1px solid #edf2f7;
  border-radius: 6px;
  padding: 10px;
  margin-top: 8px;
  background: #fbfcfd;
  cursor: pointer;
}

.nested-card:hover {
  background: #f5f8fb;
}

.star-readonly {
  color: #f9a825;
  font-size: 16px;
  white-space: nowrap;
}

.avaliacao-item {
  display: grid;
  grid-template-columns: minmax(140px, 1fr) auto;
  gap: 12px;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 8px;
  background: #ffffff;
}

.avaliacao-item.compacto {
  padding: 8px 10px;
}

.avaliacao-item-nome {
  font-weight: 600;
  color: #37474f;
}

.star-picker {
  display: flex;
  align-items: center;
  gap: 2px;
}

@media (max-width: 600px) {
  .avaliacao-item {
    grid-template-columns: 1fr;
  }
}
</style>
